export const lang = {
  title: 'riderlink',
  download: 'download'
}



// WEBPACK FOOTER //
// ./src/assets/lang/ko.js